import React from 'react';
import './App.module.scss';
import BaseLayout from "./components/BaseLayout";
import {BrowserRouter} from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";

function App() {
   return (
      <div>
         <LanguageProvider>
            <BrowserRouter>
               <BaseLayout/>
            </BrowserRouter>
         </LanguageProvider>
      </div>
   );
}


export default App;
